import { createSelector } from 'reselect'

const getUserData = state => state.user

export default createSelector(
	[ getUserData ],
	userData => userData.extra ? userData.extra.subsEnabled : true
)
